import { buildMeta } from "../../routeMeta";

export { default } from "../../../src/pages/about/index";

export function meta(args) {
  return buildMeta(
    {
      title: "About — The Atlas of Economic Complexity",
      description:
        "About the Atlas of Economic Complexity and the team at the Harvard Growth Lab.",
    },
    args,
  );
}
